export default __webpack_public_path__ + "static/media/George_HW_Bush_0006.041d2cad.jpg";